// Runtime config injected by Docker entrypoint (config.js → window.__CONFIG__).
// Falls back to Vite build-time env for local dev.
interface RuntimeConfig {
  VITE_API_URL?: string;
  VITE_SIGNALR_URL?: string;
  VITE_APP_ENV?: string;
  VITE_ANTHROPIC_API_KEY?: string;
  VITE_AI_PROVIDER?: string;
  VITE_DIGITAL_FORMS_V2_URL?: string;
  VITE_DIGITAL_FORMS_GRAPHQL_URL?: string;
}

const runtimeConfig = (window as unknown as { __CONFIG__?: RuntimeConfig }).__CONFIG__ ?? {};

export const env = {
  apiUrl:              runtimeConfig.VITE_API_URL          ?? import.meta.env['VITE_API_URL'] as string,
  signalRUrl:          runtimeConfig.VITE_SIGNALR_URL      ?? import.meta.env['VITE_SIGNALR_URL'] as string,
  anthropicApiKey:     runtimeConfig.VITE_ANTHROPIC_API_KEY ?? import.meta.env['VITE_ANTHROPIC_API_KEY'] as string | undefined,
  /** Active AI provider key ("gemini" | "claude" | ...). When set in dev, routes to PortalAPI. */
  aiProvider:          runtimeConfig.VITE_AI_PROVIDER      ?? import.meta.env['VITE_AI_PROVIDER'] as string | undefined,
  digitalFormsV2Url:   runtimeConfig.VITE_DIGITAL_FORMS_V2_URL   ?? import.meta.env['VITE_DIGITAL_FORMS_V2_URL'] ?? '',
  digitalFormsGraphqlUrl: runtimeConfig.VITE_DIGITAL_FORMS_GRAPHQL_URL ?? import.meta.env['VITE_DIGITAL_FORMS_GRAPHQL_URL'] ?? '',
  isDev:               import.meta.env.DEV,
} as const;
